import React from "react";
import { CurrentConversationProvider } from "utilities/atoms/conversations/current-conversation/current-conversation-provider";
import { BookviewConversationAtom } from "utilities/atoms/conversations/current-conversation/conversation-atoms";
import { useLoadConversationFromUrl } from "utilities/atoms/conversations/current-conversation/use-load-conversation-from-url.hook";
import useBreakpointRanges from "utilities/hooks/use-breakpoint-ranges";
import BookviewTabPanelFooter from "./bookview-tab-panel-footer";
import ChatPanelContent from "./chat-panel-content";
import { ChatContextType } from "constants/chat-context-types";
import useBookviewChatContext from "./use-bookview-chat-context";

const BookviewChatPanelContent: React.FC = () => {
    useLoadConversationFromUrl();
    const { inMobileView } = useBreakpointRanges();

    const { bookviewChatContext: context } = useBookviewChatContext();
    const contextList = [
        `NFPA ${context.code} (${context.edition})`,
        `${context.entityType ? `${context.entityType} ` : ""}${context.caapsNumber}`,
    ].filter((entry) => entry !== null);

    return (
        <>
            <ChatPanelContent
                context={ChatContextType.Bookview}
                contextList={contextList}
                applicationContext={context.applicationContext}
            />
            {!inMobileView && <BookviewTabPanelFooter />}
        </>
    );
};

// Wrap the content component with the provider so we can use the hook
const BookviewChatPanel: React.FC = () => (
    <CurrentConversationProvider atom={BookviewConversationAtom}>
        <BookviewChatPanelContent />
    </CurrentConversationProvider>
);

export default BookviewChatPanel;
